
	import { Component, Vue } from 'vue-property-decorator';
	import InfoModal from '@/components/InfoModal.vue';

	@Component({
		components: { InfoModal }
	})
	export default class EndView extends Vue {
		private clicked = false;
		private seconds = 60;

		public async prescribeAnother() {
			if (this.clicked) return;
			this.clicked = true;
			const patient = await this.$state.order.reorder();
			await this.$router.push('/summary?id=' + patient?.user?.userID);
		}

		public activated(): void {
			this.clicked = false;
			this.seconds = 60;
			this.timeOut();
		}

		async timeOut() {
			await new Promise((p) => setTimeout(p, 1000));
			this.seconds--;
			if (this.seconds > 0) {
				this.timeOut();
			} else if (this.$router.currentRoute.path === '/end-view' && this.seconds > -1) {
				await this.endSession();
			}
		}

		deactivated() {
			this.seconds = -1;
		}

		public back() {
			this.$router.push('summary');
		}

		public async endSession() {
			await this.$router.push('patients');
			window.location.reload();
		}
	}
